import React, { useEffect, useMemo, useState } from "react";
import { FruitifyContainer } from "../../../shared-components/Containers";
import { Typography } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { useApiClient } from "../../../api";
import { FruitifyAssignmentTemplateSearch } from "../components/FruitifyAssignmentTemplateSearch";
import { withPageTracking } from "../../../services/postHog";

const AssignmentCreateFromExisting = () => {
  const [searchParams] = useSearchParams();
  const classId = searchParams.get("classId");
  const createGroupWithName = searchParams.get("createGroupWithName");

  const ApiClient = useApiClient();
  const [assignments, setAssignments] = useState([]);

  const fetchAssignments = async () => {
    try {
      const response = await ApiClient.assignment.getAllAssignmentTemplates({
        schoolClass: classId,
      });
      if (response) {
        setAssignments(response.allAssignmentTemplates);
      }
    } catch (error) {
      console.error("Failed to fetch assignments", error);
    }
  };

  useEffect(() => {
    fetchAssignments();
  }, []);

  const viewTemplateSearchParams = useMemo(() => {
    const params = new URLSearchParams();

    if (createGroupWithName) {
      params.set("createGroupWithName", createGroupWithName);
    }

    return params;
  }, [createGroupWithName]);

  return (
    <FruitifyContainer>
      <Typography variant="h3" fontWeight="bold">
        Choose assignment
      </Typography>
      <FruitifyAssignmentTemplateSearch
        excludeTitle
        assignments={assignments}
        viewTemplateSearchParams={viewTemplateSearchParams}
        templates
      />
    </FruitifyContainer>
  );
};

export default withPageTracking(AssignmentCreateFromExisting, {
  feature: "assignment-create-from-existing",
});
